import React from 'react';

const EmptyMessage = ({text}) => {
  return (
    <p
    style={{
      textAlign: "center",
      color: "#CBCBCB",
      fontSize: 16,
      width: "100%",
      margin: "0 auto",
      paddingTop: 200,
    }}
  >
  {text}
  </p>
  )
}

export default EmptyMessage


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/EmptyMessage/index.js